import { render, staticRenderFns } from "./flight-follow.vue?vue&type=template&id=0a97fb01&"
import script from "./flight-follow.vue?vue&type=script&lang=js&"
export * from "./flight-follow.vue?vue&type=script&lang=js&"
import style0 from "./flight-follow.vue?vue&type=style&index=0&id=0a97fb01&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports